export default __webpack_public_path__ + "static/media/WaylonSmithers.02564d4f.png";